import { Controller } from 'stimulus';
import dataLayer from '../helpers/dataLayer';

class SavingsCalculatorController extends Controller {
  connect() {
    this.onSavingsCalculatorInputChange();
  }

  onSavingsCalculatorInputChange() {
    const averageFuelUsageInLiterPerKilometer = 0.083;
    const percentageThatIsSaved = 0.15;
    const values = {
      vehicleCount: parseInt(this.vehicleCountTarget.value, 0),
      planningHours: parseInt(this.planningHoursTarget.value, 0),
      kilometersPerVehicle: parseInt(this.kilometersPerVehicleTarget.value, 0),
      hourlyWage: parseInt(this.hourlyWageTarget.value, 0),
      workingHoursPerVehicle: parseInt(this.workingHoursPerVehicleTarget.value, 0),
      fuelPricePerLiter: parseFloat(this.fuelPricePerLiterTarget.value),
    };

    // Calculate the totals for one day
    const totalWorkingHoursDrivers = values.vehicleCount * values.workingHoursPerVehicle;
    const totalFuelConsumption = (values.vehicleCount * values.kilometersPerVehicle)
      * averageFuelUsageInLiterPerKilometer;

    // When using RouteLogic planning will require only one hour per day.
    // We calculate the number of hours we save
    const totalWorkingHoursPlanning = values.planningHours > 1 ? values.planningHours - 1 : 0;

    const totalWageCostsDrivers = totalWorkingHoursDrivers * values.hourlyWage;
    const totalFuelCosts = totalFuelConsumption * values.fuelPricePerLiter;

    // Take 15% of the totals
    const driversWagesCostsSavings = totalWageCostsDrivers * percentageThatIsSaved;
    const fuelCostsSavings = totalFuelCosts * percentageThatIsSaved;
    const planningWagesCostsSavings = totalWorkingHoursPlanning * values.hourlyWage;

    // Multiply the totalSavings to get the totalSavings for one month
    const totalSavings = Math.round(
      (driversWagesCostsSavings + fuelCostsSavings + planningWagesCostsSavings) * 21,
    );

    this.totalSavingsTarget.innerText = Number.isNaN(totalSavings) ? 0 : totalSavings.toLocaleString('NL-nl');
  }

  // eslint-disable-next-line class-methods-use-this
  onButtonClick(event) {
    const { currentTarget } = event;

    dataLayer.event('Savings Calculator Register Button', 'click', currentTarget.getAttribute('data-plan'));

    return true;
  }
}

SavingsCalculatorController.targets = [
  'vehicleCount',
  'planningHours',
  'kilometersPerVehicle',
  'hourlyWage',
  'workingHoursPerVehicle',
  'fuelPricePerLiter',
  'totalSavings',
];

export default SavingsCalculatorController;
